import {Component, OnInit} from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpService} from '../services/http.service';

@Component({
    selector: 'app-books',
    templateUrl: './books.component.html'
})
export class BooksComponent implements OnInit {
    public booksList = null;
    public author = {};
    public AppConfig = AppConfig;
    public mediaList = null;

    constructor(public http: HttpService) {
        this.getBooks();
        this.getMediaFiles();
        AppConfig.instance.getAllTextBlocks(textblocks => {
            this.author = textblocks['about_author_books'].content;
        });
    }

    ngOnInit() {
    }


    getBooks() {
        this.http.get(AppConfig.baseUrlApi + 'books/api_books_all_short').subscribe(response => {
            this.booksList = response.content;
        }, error => {
            console.log(error);
        });
    }

    getMediaFiles() {
        this.http.get(AppConfig.baseUrlApi + 'media/api_media/img').subscribe(response => {
            this.mediaList = response.content.slice(0, 3);
        }, error => {
            console.log(error);
        });
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/books/books.component.ts